import { ComponentButton } from './ComponentButton';
import { BackButton as BackButtonType } from '@/schemas/sceneDataSchema';

export const BackButton = ({ component }: { component: BackButtonType }) => {
  const onClick = () => {
    return void window.history.back();
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
